@if (showLiveChat) {
  <gb-live-chat></gb-live-chat>
}

<div class="gb-unauthenticated-shell">
  <div class="gb-unauthenticated-background"></div>
  <div class="gb-unauthenticated-content">
    @if (showLogo) {
      <div class="gb-unauthenticated-logo">
        <gb-logo-light></gb-logo-light>
      </div>
    }

    <ng-content select="[side-panel]"></ng-content>

    <div class="gb-unauthenticated-card">
      <ng-content></ng-content>
    </div>

    <ng-content select="[footer]"></ng-content>
  </div>
</div>
